import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontRobotoCondensed, theme } from "@product/scmp-sdk";

import { BaseLink } from "~/components/common/base-link";
import { ContentItemHomeComment } from "~/components/content/content-item-render/variants/home-comment";
import { ContentItemHomeHarry } from "~/components/content/content-item-render/variants/home-harry";

export const StyledContentItemHomeComment = styled(ContentItemHomeComment)`
  flex: 1;
`;

export const StyledContentItemHomeHarry = styled(ContentItemHomeHarry)`
  flex: 1;
`;

export const Title = styled(BaseLink)`
  margin-block-end: 20px;

  color: #00000080;
  font-size: 20px;
  font-family: ${fontRobotoCondensed};
`;

export const CommentItems = styled.div`
  display: flex;
  flex-direction: column;

  padding-block-end: 20px;
  border-block-end: 1px solid #0000001a;

  ${theme.breakpoints.up("homeDesktop")} {
    grid-template-columns: 1fr;
  }
`;

export const Container = styled.div`
  padding: 20px;

  border-radius: 8px;

  outline: 1px solid #00000033;

  ${StyledContentItemHomeComment}:not(:last-child), ${StyledContentItemHomeHarry}:not(:last-child) {
    border-block-end: 1px solid #0000001a;

    padding-block-end: 20px;
    ${theme.breakpoints.up("tablet")} {
      border-block-end: 0;

      padding-block-end: 0;
    }
    ${theme.breakpoints.up("homeDesktop")} {
      padding-block-end: 20px;
      border-block-end: 1px solid #0000001a;
    }
  }
`;

const RowStyle = css`
  display: flex;
  flex-direction: column;
  gap: 20px;
  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
  }
  ${theme.breakpoints.up("homeDesktop")} {
    flex-direction: column;
  }
`;

export const FirstRow = styled.div`
  ${RowStyle};
`;

export const SecondRow = styled.div`
  ${RowStyle};
  border-block-start: 1px solid rgba(0, 0, 0, 0.1);

  margin-block-start: 20px;
  padding-block-start: 20px;
`;

export const MoreLink = styled(BaseLink)`
  margin-block-start: 20px;
  padding-block: 7px;
  padding-inline: 8px;

  color: #4585ff;
  font-size: 14px;

  border: 1px solid #4585ff;
  border-radius: 2px;
`;
